<template>
  <div>
    <input 
      type="number" 
      class="form-control"
       :min="0"
      :id="id"
      :name="name"
      :value="value"
       onkeydown="return event.keyCode !== 69"
      @input="updateValue"
      :max="max"
      :maxlength="maxlength"
      v-on:input="validateMaxRange"
    />
  </div>
</template>

<script>

var testfunction = function () {
  console.log("tet");
};
export default {
  name: "InputNumber",
  props: {
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100000000000,
    },
    maxlength: {
      type: Number,
      default: 100000000000,
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
      this.$emit("onKeyPress", event.target.value);
    },
    validateMaxRange(event) {
      // Retrieve the input value
      const value =parseInt(event.target.value);

      // Check if the value is negative
      if (value < 0) {
        // Set the input value to an empty string
        this.$emit("input", 0);
        this.$emit("onKeyPress",0);
        return; // Exit the method
      }

      // Set the minimum and maximum lengths
      const minLength = 0;
      const maxLength = this.maxlength?this.maxlength:10;

      // Check if the value is within the allowed length range
      if (event.target.value.length < minLength || event.target.value > maxLength) {
        // Adjust the input value to fit within the length range
        document.getElementById(this.id).value = parseInt(event.target.value.slice(0, maxLength));
        this.$emit("input",parseInt(event.target.value.slice(0, maxLength)));
      this.$emit("onKeyPress", parseInt(event.target.value.slice(0, maxLength)));
      }
    },
  },
};
</script>